<span
  [class]="merge('av', class)"
  [style.width.px]="size"
  [style.height.px]="size"
  [style.font-size.px]="size * 0.36"
  aria-hidden="true"
>
  @if (showImage) {
    <img class="av__img" [src]="imageSrc" alt="" (error)="onImageError()" />
  } @else {
    <span [class]="merge('av__initials', InitialClass)">{{ Inititals }}</span>
  }
</span>
